import BodyTextWithCTASkeleton from 'components/Banner/BodyTextWithCTA/BodyTextWithCTA.fallback';

import { BodyTextSliderProps } from './types';

import useStyles from './style';

function BodyTextSliderFallback({ carouselData, title }: BodyTextSliderProps) {
  const { root, titleSkeleton } = useStyles();

  return (
    carouselData && (
      <div className={root}>
        {title && (
          <h2 className={titleSkeleton}>
            <i className="skeleton" />
          </h2>
        )}
        <BodyTextWithCTASkeleton carouselLayout />
      </div>
    )
  );
}

export default BodyTextSliderFallback;
